module.exports = __webpack_public_path__ + "static/media/team-fcangrand.54e171c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/team-fcangrand.jpg
// module id = 294
// module chunks = 0